// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer__root--31ZVJ Container__container--2Emzb","linksWrapper":"Footer__linksWrapper--4PZoy","links":"Footer__links--2HiEc","copyright":"Footer__copyright--1fo7B"};